var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.92906 10.8753C9.90406 10.8152 9.86187 10.7638 9.80777 10.7277C9.75367 10.6915 9.69009 10.6721 9.625 10.6719H7.32813V1.375C7.32813 1.28798 7.29356 1.20452 7.23202 1.14298C7.17049 1.08145 7.08703 1.04688 7 1.04688C6.91298 1.04688 6.82952 1.08145 6.76798 1.14298C6.70645 1.20452 6.67188 1.28798 6.67188 1.375V10.6719H4.375C4.30991 10.6721 4.24633 10.6915 4.19223 10.7277C4.13814 10.7638 4.09594 10.8152 4.07094 10.8753C4.04646 10.9352 4.04025 11.0011 4.05309 11.0645C4.06594 11.128 4.09726 11.1862 4.14313 11.2319L6.76813 13.8569C6.82965 13.9183 6.91305 13.9528 7 13.9528C7.08696 13.9528 7.17035 13.9183 7.23188 13.8569L9.85688 11.2319C9.90274 11.1862 9.93406 11.128 9.94691 11.0645C9.95975 11.0011 9.95355 10.9352 9.92906 10.8753Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDown);
export default __webpack_public_path__ + "static/media/icon-arrow-down.01a19bf81ff2f6bde7e2f3a22f127043.svg";
export { ForwardRef as ReactComponent };